import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f4c217e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]

import { onMounted, ref } from "vue";
import ProgressAnimation from "@/assets/animation/progress_dark.json";


export default /*#__PURE__*/_defineComponent({
  __name: 'buttonLoading',
  props: {
  title: { type: String, required: false, default: "" },
  disabled: { type: Boolean, default: false },
  isLoading: {
    type: Boolean,
    required: false,
    default: false,
  },
  classIcon: {
    type: String,
    required: false,
    default: "",
  },
},
  emits: ["click-action"],
  setup(__props, { emit: emits }) {

const props = __props;





const LottieAnimation: any = ref(null);

onMounted(async () => {
  if (process.env.NODE_ENV === "test") {
    LottieAnimation.value = { render: () => null };
  } else {
    LottieAnimation.value = (await import("lottie-web-vue")).LottieAnimation;
  }
});

const onClick = () => {
  if (props.disabled || props.isLoading) {
    return;
  }
  emits("click-action");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    disabled: __props.disabled,
    "data-cy": "create-and-upate-assessment-create-btn",
    class: _normalizeClass(`tw-h-[39px] tw-cursor-pointer tw-flex tw-flex-col tw-items-center tw-self-end tw-gap-2.5 tw-px-[18px] tw-rounded-[26.909px] tw-bg-[#387DFF] tw-text-white tw-text-center tw-text-[15px] tw-not-italic tw-font-[500] tw-leading-[100%] ${
      __props.disabled ? 'disabled' : 'hover:tw-bg-[#096cdb]'
    } ${__props.isLoading ? 'tw-overflow-hidden' : 'tw-py-3'} createBtn`),
    onClick: onClick
  }, [
    (__props.isLoading)
      ? (_openBlock(), _createBlock(_unref(LottieAnimation), {
          key: 0,
          class: _normalizeClass(`tw-h-[39px] tw-w-[38px] ${__props.classIcon}`),
          "animation-data": _unref(ProgressAnimation),
          "auto-play": true,
          loop: true
        }, null, 8, ["class", "animation-data"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, _toDisplayString(__props.title), 1)
  ], 10, _hoisted_1))
}
}

})